<template>
  <div class="Rdcenter">
    <div class="Rdcenterc">

      <div class="center">
        <div class="swipercover">
          <div class="swiper-container" id="Rdcenterswiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <!--<img src="../../assets/img/temp/1.png" alt="">-->
                <img v-if="!obj.videoSrc" :src="obj.img" alt="">
                <img v-else :src="obj.videoImgurl" alt="" @click="showVideo">
              </div>
            </div>
            <!-- Add Pagination -->
            <!--<div class="swiper-button-prev"></div>-->
          </div>
        </div>
        <div class="text">
          <h1>{{obj.name}}</h1>
          <!--<p>研发中心的形式可以是外国投资者（包括外商投资设立的投资性公司）依法设立的中外合资、合作、外资企，也可以是设在外商投资企业内部的独立部门或分公司。</p>-->
          <div>{{obj.desc}}</div>
          <!-- <a v-if="obj.haoyue" :data-id="obj.haoyue"  @click="readmore">查看更多</a> -->
        </div>
      </div>
      <!--<p class="title">区域品牌大事记</p>-->
    </div>
  </div>

</template>

<script>
  export default {
    name: 'chanDi',
    props: {
        pluginJson: {
            // type: Object
        },
        // pluginIndex: {
        //     type: String
        // }
    },
    data () {
      return {
        obj: {
          title:'',
          desc: '',
          haoyue: '',
          img: '',
          videoSrc:'',
          videoImgurl: ''
        },
        activeIndex: 0,
        arr: [ 1, 2,3,4 ,5, 6, 7],
      }
    },
    created () {
    },
    mounted () {
      console.log('pluginJson',this.pluginJson)

      this.obj.name= this.pluginJson[0]['name']
      this.obj.desc= this.pluginJson[0]['description'].split('#')[0]
      this.obj.haoyue= this.pluginJson[0]['description'].split('#')[1]
      this.obj.img= this.pluginJson[0]['thumbnail']
      this.obj.videoSrc= this.pluginJson[0]['video']['videoIntro']
      this.obj.videoImgurl= this.pluginJson[0]['video']['videoCoverImgUrl']

    },
    watch: {
      pluginJson: {
        handler(newvalue, oldvalue){

        },
        deep: true
      }
    },
    methods: {
      readmore(){
        this.$emit('showMedia',{ articleList: this.obj.haoyue, type: 'textMarker' })
      },
      showVideo(){
        this.$emit('showMedia',{'type':'video','src':this.obj.videosrc})
      },
      changeIndex (index) {
        if (this.activeIndex !== index) {
          this.activeIndex = index
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
  @function rem($px) {
    @return $px * (1/40) * 1rem;
  }
  .Rdcenter{
    position: absolute;
    top: 0;
    left: 0;
    background: #FFFFFF;
    width: 100%;
    height: 100%;
    padding-top: rem(84);
    .title{
      position: absolute;
      top:rem(101);
      left: rem(144);
      /*color: #008C8C;*/
      color: var(--body-color);
      font-size: rem(24);
      z-index: 1;
    }
    .zhezhao1{
      width: rem(95);
      height: rem(526);
      position: absolute;
      top: rem(84);
      left: 0;
      background: linear-gradient(360deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
      filter: blur(0px);
    }
    .zhezhao2{
      width: rem(95);
      height: rem(526);
      position: absolute;
      top: rem(84);
      right: 0;
      background: linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
      filter: blur(0px);
    }
    .text{
      /*color: #008C8C;*/
      color: var(--body-color);
      text-align: center;
      div{
        margin-top: rem(59);
        font-size: rem(25);
        line-height: rem(36);
        width: 100%;
        height: rem(300);
        overflow-y: scroll;
        /*text-align: left;*/
        word-break: normal;
        text-align: justify;
        p{

        }
      }
      span{
        margin-top: rem(17);
        display: inline-block;
        font-size: rem(20);
        text-align: center;
        line-height: rem(36);
      }
    }
  }
  .Rdcenterc{
    background-color: rgba(235, 235, 235, 1);
    /*overflow: visible;*/
    /*margin-top: rem(84);*/
    width: 100%;
    height: 100%;
    padding-top: rem(84);

    .center{
      background-color: #FFFFFF;
      padding-bottom: rem(40);
      width: 100%;
      height: rem(560);
      text-align: center;
      box-sizing: border-box;
      overflow: hidden;
      /*height: rem(560);*/
      .swipercover{
        height: 13rem;
        float: right;
        width: 50%;
        background: #ffffff;
        border-radius: rem(35);
        margin-top: rem(40);
      }
      .swiper-container {
        width: rem(640);
        height: rem(480);
        overflow: hidden;
        border-radius: rem(35);
        transform:translate3d(0,0,0);
        .swiper-wrapper{
          border-radius: rem(35);
          width: rem(640);
          height: rem(480);
        }
      }
      .swiper-slide {
        /*width: 100%;*/
        transform:translate3d(0,0,0);
        border-radius: rem(35);
        width: rem(640);
        overflow: hidden;
        height: rem(480);
        border: 1px solid #FFFFFF;
        text-align: center;
        font-size: rem(18);
        /*background: pink;*/
        /*border-top-bottom-radius: rem(35) ;*/
        /*background: url("../../assets/img/temp/1.png") center center no-repeat;*/
        /*background-size: 100% 100%;*/
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        overflow: hidden;
        /*text-align: center;*/
        /*font-size: 18px;*/
        /*background: #fff;*/
        /*text-align: center;*/
        /*font-size: 18px;*/
        /*background: #fff;*/

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        img{
          width: rem(640);
          height: rem(480);
          overflow: hidden;

        }
      }
    }

    .swiper-button-next{
      width: rem(38);
      height: rem(38);
      background: url("../../assets/img/pc/right.png") center center no-repeat;
      background-size: 100% 100%;
      top: 50%;
      /*left: rem(1330);*/
      z-index: 2;
      margin-top: rem(-19);
      right: rem(22);
    }
    .swiper-button-prev{
      top: 114%;
      left: rem(85);

      width: rem(38);
      height: rem(38);
      background: url("../../assets/img/pc/left.png") center center no-repeat;
      background-size: 100% 100%;
    }
    .text{
      width: 50%;
      padding-left: rem(60);
      padding-right: rem(40);
      box-sizing: border-box;
      position: absolute;
      top: rem(167);
      text-align: left;
      left: 0;
      background-color: #FFFFFF;
      h1{
        font-size: rem(36);
        margin-top: rem(40);
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        /*color: #008C8C;*/
        color: var(--body-color);
        /*line-height: rem(50);*/
      }
      p{
        font-size: rem(25);
        /*color: #008C8C;*/
        color: var(--body-color);
        font-weight: 400;
        line-height: rem(40);
        width: 100%;
        text-align: left;
      }
      a{
        cursor: pointer;
        /*color: #008C8C;*/
        color: var(--body-color);
        text-decoration:underline;
        text-align: right;
        display: block;
        font-size: rem(18);
        margin-top: rem(150);
      }
    }
  }


</style>
